import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import moment from 'moment';
import { Moment } from 'moment';
import { DynamicScriptLoaderService } from '../../../services/dynamicScriptLoader.service';
import { ShuttelbussService } from '../../../services/shuttlebuss.service';
import { SnackbarService } from '../../../services/snackbar.service';

@Component({
    selector: 'app-payment-bottomsheet',
    templateUrl: './payment-bottomsheet.component.html',
    styleUrls: ['./payment-bottomsheet.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentBottomsheetComponent implements OnInit {
  successMessage = 'Tack för din bokning. Välkommen åter!';
  isLoading = false;
  parkingTo: Moment;

  constructor(
    // @Inject(MAT_BOTTOM_SHEET_DATA) public userInput: any,
    @Inject(MAT_DIALOG_DATA) public userInput: any,
    public shuttleBussService: ShuttelbussService,
    private bottomSheetRef: MatBottomSheetRef<PaymentBottomsheetComponent>,
    private dialogRef: MatDialogRef<PaymentBottomsheetComponent>,
    public snackbar: SnackbarService,
    public router: Router,
    public dynamicScriptLoaderService: DynamicScriptLoaderService
  ) {}

  ngOnInit(): void {
    console.log('userInput',this.userInput);
    this.parkingTo = moment(this.userInput.customer.parking.parkingto).add(3, 'hours');
    console.log('customer', this.userInput.customer);
  }

  reset(): void {
    this.shuttleBussService.resetForm();
  }

  cancel() {
    this.dialogRef.close();
  }

  sendConfirmation() {
    this.isLoading = true;
    this.dialogRef.close({
      showPayment: true,
      customer: this.userInput.customer,
      cart: this.userInput.cart
    });
    this.router.navigate(['/flygets/checkout/payment/', this.userInput.cart.orderId]);
    this.isLoading = false;
  }
}
